import BaseService from '../../base/base_service';
import ILoyalty, { LoyaltyServiceInitParams } from './loyalty_service_interface';

class LoyaltyService extends BaseService implements ILoyalty {

  static CLASS: string = 'LoyaltyService';
  private _initParams: LoyaltyServiceInitParams = null;

  init(params: LoyaltyServiceInitParams) {
    super.init(params);
    this._initParams = params;
  }

  public getScriptLink(): string {
    return this._initParams.scriptLink;
  }

  public getClientPlatform(): number {
    return this._initParams.clientPlatform;
  }

}

export default LoyaltyService;